import type { StaticImageData } from 'next/image';

import { Flex } from '@/components/Flex';
import { Loader } from '@/components/Loader';

import * as S from './WatchProductAction.styles';

export interface WatchProductActionProps {
  altText?: string;
  buttonText: JSX.Element | string;
  imageSrc?: StaticImageData;
  isProcessing?: boolean;
  onClick: () => void;
}

export const WatchProductAction = ({
  altText,
  buttonText,
  imageSrc,
  isProcessing,
  onClick,
}: WatchProductActionProps) => (
  <S.AddButton onClick={onClick}>
    <Flex>
      {isProcessing ? (
        <Loader height={35} noMargin size='sm' />
      ) : (
        <S.PlusIcon />
      )}
      <S.ButtonText>{buttonText}</S.ButtonText>
    </Flex>
    {imageSrc && (
      <S.ButtonImageWrapper>
        <S.ButtonImage alt={altText ?? ''} fill sizes='10vw' src={imageSrc} />
      </S.ButtonImageWrapper>
    )}
  </S.AddButton>
);
